import React, { useEffect, useState } from "react";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AboutUs = () => {
  const aboutUs = `${API_BASE_URL}/static/about-us`;

  const [aboutData, setAboutData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetch(aboutUs);
      const data = await response.json();
      setAboutData(data?.data[0]);
      console.log(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      {aboutData ? (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-5xl w-full text-justify">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-800">
            {aboutData?.heading}
          </h1>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_1}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_2}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_3}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_4}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_5}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_6}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
            {aboutData?.paragraph_7}
          </p>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default AboutUs;
